import { Component } from "@angular/core";

@Component({
    selector: "generic-error",
    imports: [],
    templateUrl: "./generic-error.component.html"
})
export class GenericErrorComponent {
    
}